import { useSaveFilter } from '~/core/shared/api/middle-office/filters';
import { useTenantedApplicationConfig } from '~/core/shared/contexts';
import { DocumentFilter } from '~/core/shared/types';
import { useDefinition } from '../../contexts';
import { buildDefinitionParams } from '../logic/buildDefinitionParams';

export const useSaveFilterQuery = (
  onSuccess: (filter: DocumentFilter) => void,
) => {
  const config = useTenantedApplicationConfig();
  const { definition } = useDefinition();
  return useSaveFilter(buildDefinitionParams(definition, config), {
    onSuccess,
  });
};
